import React, { useEffect, useState } from 'react';
import { classNames } from 'assets/utils/helper';
import GetViewportSize from '../../assets/utils/getViewportSize';
import { useRouter } from 'next/router';
import Icons from 'components/atoms/Icons';
declare global {
  interface Window {
    grecaptcha: any;
  }
}

const RequestAppt = () => {
  const [popupOpen, setPopupOpen] = useState(false);
  const [viewportSize, setViewportSize] = useState<string | null>(null);
  const [isMobile, setIsMobile] = useState<boolean | null>(null);
  const handleClick = () => setPopupOpen(true);

  const router = useRouter();
  const { path, ...routerNoPath } = router.query;

  useEffect(() => {
    window.addEventListener('click', e => {
      if (!(e.target as HTMLElement).closest('.request-appt')) {
        setPopupOpen(false);
      }
    });
    setViewportSize(GetViewportSize());
    const handleResize = () => setViewportSize(GetViewportSize());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (viewportSize !== 'xl' && viewportSize !== 'xxl') {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [viewportSize]);

  return (
    <div className="overhauled">
      <div
        className={classNames(
          'request-appt',
          isMobile ? 'nav-action has-sub-nav' : '',
          popupOpen ? 'active' : ''
        )}
      >
        <button
          type="button"
          className="btn-primary no-icon request-appt-btn"
          onClick={() => handleClick()}
        >
          Request Appointment
        </button>
        <div
          className={classNames(
            isMobile ? 'sub-nav-menu request-appt-popup' : 'request-appt-popup',
            !popupOpen ? 'closed' : 'open active'
          )}
          {...(!isMobile && {
            onMouseLeave: () => {
              setPopupOpen(false);
            },
          })}
        >
          {isMobile && popupOpen && (
            <div className="sub-link-item">
              <div
                className="sub-link-heading"
                tabIndex={0}
                onClick={() => setPopupOpen(false)}
              >
                <Icons id="chevron-left-icon" />
                Request Appointment
              </div>
            </div>
          )}
          <div className="popup-details">
            <p className="osf-nav-section-titles color-primary-dark">
              Request Appointment:
            </p>
            <p className="osf-nav-top-level color-primary-dark">I am a:</p>
            <button
              className="btn-secondary no-icon"
              onClick={() => {
                router.push(
                  {
                    pathname: '/appointment-request',
                    query: {
                      ...routerNoPath,
                      type: 'patient-request',
                    },
                  },
                  undefined,
                  {
                    shallow: false,
                  }
                );
              }}
            >
              New Patient
            </button>
            <button
              className="btn-secondary no-icon"
              onClick={() => {
                router.push(
                  {
                    pathname: '/appointment-request',

                    query: {
                      ...routerNoPath,
                      type: 'provider-request',
                    },
                  },
                  undefined,
                  {
                    shallow: false,
                  }
                );
              }}
            >
              Physician
            </button>
            <div className="bottom-content">
              <p className="osf-nav-section-titles color-primary-dark">
                Speak to a Care Advocate
              </p>
              <p className="osf-nav-section-titles call-text">
                <span>Call 1-844-OSF-4-HOPE |</span>
                <span> 1-844-673-4467</span>
              </p>
              <p className="osf-nav-body-copy">
                Available Monday–Friday from 8 a.m. to 4:30 p.m.
              </p>
            </div>
          </div>
        </div>
        <div id="request-appt-root"></div>
      </div>
    </div>
  );
};

export default RequestAppt;
